import { useCallback, useReducer, useRef } from 'react';
export const useEnhancedReducer = (reducer, initState, initializer = (initialValue) => initialValue) => {
    const lastState = useRef(initState);
    const getState = useCallback(() => lastState.current, []);
    return [
        ...useReducer((state, action) => (lastState.current = reducer(state, action)), initState, initializer),
        getState,
    ];
};
